const Currency = Object.freeze({
  EUR: '€',
  USD: '$',
  GBP: '£',
})

export default Currency
